import { CommonAxiosGet, CommonAxiosPost } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import { FaArrowDownLong, FaArrowUpLong } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight, FaCheckSquare, FaPrint, FaWindowClose } from "react-icons/fa";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import { IoIosArrowDown } from "react-icons/io";
import Sweetalert from "../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { CONTEXT_NAME } from "../../../CommonUtilities/Validations/RegularExpAndVar";
import { useReactToPrint } from "react-to-print";
import { Afterprint } from "../BasicPreview";

export default function FinalWebOptions() {
  const [status, setStatus] = useState(false);
  function handleBackStatus() {
    setStatus(!status)
  }
  const [manDetails, setManDetails] = useState();
  const [SelectedOption, SetSelectedOption] = useState([]);
  const [OptionList, SetOptionList] = useState([]);
  const [totalData, setTotalData] = useState([]);
  let componentRef = useRef();
  function SelectedOptionsFunction() {

    let linkurl = config.url.CONTEXT_READ_URL + "getVcancySchoolsForCandidates";
    CommonAxiosGet(linkurl).then((response) => {
      if (response?.data?.status === true) {
        let data_s = response?.data?.data || [];
        let data_final_save = data_s?.filter((val) => val?.save_flag === 'S');
        // console.log('data_final_save',data_final_save?.length> 0)
        setStatus(data_final_save?.length > 0);
        let data_submitted = data_s?.filter((val) => val?.preference_id !== null)
        // let p_save = data_s?.filter((val) => val?.save_flag === 'PS')
        SetSelectedOption(data_submitted?.length > 0 ? data_submitted : [])
        let main_s = [...new Map(data_s?.map(item => [item.mandal_code, { mandal_code: item.mandal_code, block_name: item.block_name }])).values()];
        setManDetails(main_s);
        setTotalData(data_s);
      } else {
        setTotalData([])
      }
    });
  }
  useEffect(() => {
    SelectedOptionsFunction();
  }, []);

  useEffect(() => {
    const groupedData = Object.values(
      totalData?.reduce((acc, curr) => {
        const code = curr.mandal_code;
        const block_name = curr.block_name;
        if (!acc[code]) {
          acc[code] = { mandal_code: code, block_name: block_name, count: 1 };
        } else {
          acc[code].count += 1;
        }
        return acc;
      }, {})
    );
    const groupedData_sub = Object.values(
      SelectedOption?.reduce((acc, curr) => {
        const code = curr.mandal_code;
        const block_name = curr.block_name;
        if (!acc[code]) {
          acc[code] = { mandal_code: code, block_name: block_name, count: 1 };
        } else {
          acc[code].count += 1;
        }
        return acc;
      }, {})
    );
    const result = groupedData?.filter(item1 => {
      const match = groupedData_sub?.find(item2 => item2.mandal_code === item1.mandal_code);
      return !match || match.count !== item1.count;
    });
    // console.log("groupedData", groupedData);
    // console.log("groupedData_sub", groupedData_sub);
    // console.log("result", result);

    setManDetails(result);
  }, [OptionList, SelectedOption])
  const Formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      mandalCode: '',
      otp: '',
      selfCheck: ''
    },
    onSubmit: () => {

      let totalvaluesCount = totalData?.length;
      let check_length = SelectedOption?.length;
      if (check_length === 0) {
        return Sweetalert('Please Check Atleast One School', 'warning')
      }
      if (totalvaluesCount !== check_length) {
        return Sweetalert('Please Select All Preferences for each Mandal', 'warning')
      }
      if (totalvaluesCount === check_length) {
        handleCShow();

      }
    }
  })
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
  function submitValues() {
    let values = {
      otp: Formik?.values?.otp,
      candidateId: loginreducer?.username,
      preferences: []
    }
    SelectedOption?.forEach((val, i) => {
      values.preferences[i] = {
        schoolCode: val.school_code,    // Correct assignment for cat
        preferenceNo: i + 1,         // Correct assignment for pref (starting at 1)
      };
    });
    let url = backStatus === true ? config.url.CONTEXT_URL + "webOptionsBack" : config.url.CONTEXT_URL + "save-candidate-school-preferences"
    Swal.fire({
      title: 'Are you sure want to submit?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: 'Submit',
    }).then((res) => {
      if (res.isConfirmed) {
        CommonAxiosPost(url, values).then((res) => {
          if (res?.data?.status === true) {
            Sweetalert('Successfully submitted', 'success');
            Formik.setFieldValue('mandalCode', '');
            Formik.setFieldValue('otp', '');
            Formik.setFieldValue('selfCheck', '');
            setBackStatus(false);
            SelectedOptionsFunction();
            handledClose();
          }
          else {
            Sweetalert(res?.data?.sdesc, "error")
          }
        })
      }
      else if (res.isDismissed) {
        handledClose();
      }
    })
  }
  const [dshow, setdShow] = React.useState(false);
  const handleCShow = () => { setdShow(true) };
  const handledClose = () => {
    setdShow(false);
    setOtpBtn(true)
  };
  const [showOtpBtn, setOtpBtn] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);



  function sendOtp() {
    Formik.setFieldValue('otp', '')
    Swal.fire({
      title: backStatus === true ? 'Do you want to sent back your Web Options' : 'Are you Sure Want to Submit?',
      html: `OTP will be Send to your Mobile No.`, icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send OTP",
    }).then((res) => {
      if (res.isConfirmed) {
        let otpUrl = config.url.CONTEXT_URL + "preferences-generate-otp"
        CommonAxiosPost(otpUrl).then((rres) => {
          if (rres?.data?.status === true) {
            setOtpBtn(false);
            setTimer(180);
          }
          else if (rres?.data?.scode === '03') {
            Sweetalert(rres?.data?.sdesc, "warning")

          } else {
            Sweetalert('Internal Server Issue', "warning")
          }

        })
      }
    })


  }
  const [timer, setTimer] = useState(180); // Timer in seconds
  useEffect(() => {
    let interval = null;
    if (!showOtpBtn) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            if (prevTimer < 122) {
              setResendOtp(true);
              return prevTimer - 1;
            } else if (prevTimer > 1) {
              return prevTimer - 1;
            }
            else {
              clearInterval(interval);
              setResendOtp(true); // Enable resend button when timer reaches 0
              return 0;
            }
          }
        });
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showOtpBtn]);

  const formatTime = (timeInSeconds) => {
    if (isNaN(timeInSeconds) || timeInSeconds < 0) {
      return "0:00";
    }
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };
  const resendOTP = () => {
    Formik.setFieldValue("otp", "")
    sendOtp()

  };
  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${loginreducer?.username}_DSC_WEB_OPTIONS`,
    removeAfterPrint: true,
    pageStyle: `
  @media print {
   @page{
      size: A3 portrait !important;
   }
    table {
      width: 100% !important;
      table-layout: fixed !important;
      border-collapse: collapse !important;
    }

    .td-one {
      width: 10% !important;
    }

    .td-two {
      width: 90% !important;
  
    }
  }
`

  });
  const [backStatus, setBackStatus] = useState(false)
  return (
    <div>
      <div className="pop pop-fix">
        <Modal
          size="xl"
          className="pop pop-fix"
          show={dshow}
          onHide={handledClose}
          backdrop="static"
          style={{ maxWidth: "100%", width: "100%" }}
        >

          <Modal.Header>
            <Modal.Title>
              {CONTEXT_NAME} - WEB OPTIONS
            </Modal.Title>
            <button
              type="button" onClick={() => {
                handledClose()
              }}
              style={{ fadeType: "out" }}
              variant="danger"
              aria-label="Close" className='btn btn-end'
            >
              <h4>
                <FaWindowClose className="text-danger" size={32} />
              </h4>
            </button>
          </Modal.Header>
          <Modal.Body>
            <BasicData loginreducer={loginreducer} totalData={totalData} />
            <WeboptionsPreview SelectedOption={SelectedOption} />
          </Modal.Body>
          <Modal.Footer>
            <FormikProvider value={Formik}>
              <Form onSubmit={Formik.handleSubmit} onChange={Formik.handleChange}>

                <Row className='pt-2 float-left'>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className='alert alert-warning alert-left'>
                    <Field
                      type="checkbox"
                      name="selfCheck"
                      className="form-sub"
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        Formik.setFieldValue('selfCheck', isChecked ? true : null);
                      }}
                    />
                    {/* I am personally sending my Web Options Confirmation back to get web options again. */}
                    {backStatus === false ? <span>&nbsp;
                      I declare that the order of preferences of Schools shown above are submitted by me personally through the web based service provided by School Education Department, A.P., Amaravathi. I have thoroughly checked the preferences before submitting them and as such shall not dispute with the concerned at any point of time.
                    </span> : <span>&nbsp;
                      I am personally sending my Web Options Confirmation back to get web options again.
                    </span>}
                  </Col>
                  <ErrorMessage
                    name="selfCheck"
                    component="div"
                    className="text-error"
                  />
                </Row>
                <Row>

                  {showOtpBtn === true ?
                    <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                      <button type="button" onClick={() => {
                        if (Formik?.values?.selfCheck === true) {
                          sendOtp();
                          Formik.setFieldValue('otp', '')
                        }
                        else {
                          Sweetalert("Please Check the Declaration", 'warning')
                        }
                      }} className="btn btn-sm btn-primary" >Generate OTP </button>
                    </Col>
                    : showOtpBtn === false ?
                      <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                        {resendOtp === false ?
                          <Form.Label className="input-lable mb-3 mt-4">OTP Sent to &nbsp;<b className='text-primary'>{loginreducer?.mobile_no} </b> </Form.Label> :
                          resendOtp === true ? <React.Fragment>
                            <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>
                            <Button variant="primary" type="button" className="submit-btn"
                              onClick={() => { resendOTP() }}>Resend OTP </Button></React.Fragment>

                            : ''
                        }
                      </Col> : ''}

                  {showOtpBtn === false ?
                    <React.Fragment>
                      <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                        <Form.Label className="input-lable mb-3 mt-4">Time Remaining:  {formatTime(timer)}</Form.Label>
                      </Col>
                      <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                        <Form.Group controlId="otp">
                          <Field
                            type="text"
                            name="otp"
                            className="input-field form-control mt-4"
                            placeholder="Enter OTP"
                            maxLength={6}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} className='pt-2' >
                        <Button variant="success" type="button" className="submit-btn btn-success float-end mt-3" onClick={() => {
                          if (Formik?.values?.selfCheck === true) { submitValues() }
                          else { Sweetalert("Please Check the Declaration", 'warning') }
                        }}>
                          Submit
                        </Button>
                      </Col>
                    </React.Fragment> : ''}
                </Row>   </Form>
            </FormikProvider></Modal.Footer>
        </Modal>
      </div>
      <FormikProvider value={Formik}>
        <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange}>
          <div ref={componentRef}>
            <div className='print-only-header'> <Afterprint /></div>
            <CommonPageHeading heading="Web Options - Schools" />
            {totalData?.length > 0 ? <>
              <BasicData loginreducer={loginreducer} totalData={totalData} />
              {status === false ? <>
                <WeboptionsSchools Formik={Formik}
                  SetSelectedOption={SetSelectedOption} loginreducer={loginreducer}
                  SelectedOption={SelectedOption}
                  OptionList={OptionList}
                  manDetails={manDetails}
                  hideSubmit={false}
                  SetOptionList={SetOptionList}
                  totalData={totalData}
                /></> :
                <div>
                  <WeboptionsPreview SelectedOption={SelectedOption} loginreducer={loginreducer} handleBackStatus={handleBackStatus} />
                  <div className="alert alert-warning"><FaCheckSquare color="green" />
                    I declare that the order of preferences of Schools shown above are submitted by me personally through the web based service provided by School Education Department, A.P., Amaravathi. I have thoroughly checked the preferences before submitting them and as such shall not dispute with the concerned at any point of time.</div>

                  <div className='print-in-hide'>
                    <div className="text-end">
                      {/* <button type='button' className='btn btn-primary btn-end' onClick={() => {
                    Formik.setFieldValue('selfCheck','')
                    setBackStatus(true);
                    handleCShow() }}>
                      <FaArrowLeft title="download invoice" style={{ fontSize: '22px' }} /> Back to Weboptions again</button>
                */}
                      <button type='button' className='btn btn-secondary btn-end' onClick={() => { handleprint() }}>
                        <FaPrint title="download invoice" style={{ fontSize: '22px' }} /> Print</button>
                    </div></div>
                </div>
              }
            </>
              : <div className="alert alert-danger text-center"> *** Vacancies Not Yet Confirmed ***</div>}
          </div>

        </Form></FormikProvider>
    </div>
  );
}
export function BasicData(props) {
  const { totalData, loginreducer } = props;
  return (
    <div className="table-responsive">
      <table className="table table-bordered mb-3" style={{ background: "beige" }} role="presentation">
        <tbody>
          <tr>
            <td style={{ width: '12%' }}>Candidate ID :</td>
            <td style={{ width: '20%' }}><b>{loginreducer?.username}</b></td>
            <td style={{ width: '8%' }}>Name :</td>
            <td style={{ width: '30%' }}><b>{loginreducer?.applicant_name}</b></td>
            <td style={{ width: '8%' }}>Father Name :</td>
            <td style={{ width: '20%' }}><b>{totalData[0]?.father_name}</b></td>
          </tr>
          <tr>
            <td>Management :</td>
            <td><b>{totalData[0]?.management}</b></td>
            <td>Post :</td>
            <td><b>{totalData[0]?.post_name}</b></td>
            <td>District :</td>
            <td><b>{totalData[0]?.dist_name}</b></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
export function WeboptionsPreview(props) {
  const { SelectedOption } = props;
  return (
    <div className="table-responsive"><table
      className="table table-condensed table-bordered"
      id="test-table-xls-button"
      style={{ border: "1px solid skyblue" }}
    >
      <thead
        style={{
          backgroundColor: "#dbe9f4",
          border: "1px solid skyblue",
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        <tr>
          <th className="td-one">Preference</th>
          <th className="td-two">School (Mandal-<small>kms from Mandal HQ</small>) </th>
        </tr>
      </thead>

      <tbody style={{ color: "white" }}>
        {SelectedOption?.map((val, i) => (
          <tr key={val.id} className="selectedBackground">
            <td className="text-center">{val?.preference_id ? val?.preference_id : i + 1}</td>
            <td>
              <b>
                <span
                  style={{ color: "brown", fontFamily: "Bold italic" }}>
                  {val.school_name}
                </span>
                ({val?.block_name} - {val?.route_distance})
              </b>
            </td>
          </tr>))}</tbody>

    </table></div>
  )
}
export function WeboptionsSchools(props) {
  const {
    OptionList, totalData,
    SetOptionList,
    SelectedOption,
    SetSelectedOption,
    hideSubmit,
    manDetails,
    Formik, loginreducer
  } = props;

  const handleAddOption = (val) => {

    const isAlreadySelected = SelectedOption.some(
      (option) => option.school_code === val.school_code
    );
    if (!isAlreadySelected) {
      SetSelectedOption((prev) => [...prev, val]);
      SetOptionList((prev) => prev.filter((option) => option.school_code !== val.school_code));
    }

  };
  const handleAllOption = () => {
    Swal.fire({
      text: 'Are you sure want to select all options?',
      html: `Are you sure want to select all options from <b style="color: blue;">${OptionList[0]?.block_name}</b> Mandal`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((res) => {
      if (res.isConfirmed) {
        const newSelections = OptionList.filter(
          (option) => !SelectedOption.some(
            (selected) => selected.school_code === option.school_code
          )
        );

        if (newSelections.length > 0) {
          // Add the new selections to SelectedOption
          SetSelectedOption((prev) => [...prev, ...newSelections]);

          // Remove the added options from OptionList
          SetOptionList((prev) =>
            prev.filter(
              (option) => !newSelections.some(
                (selected) => selected.school_code === option.school_code
              )
            )
          );
        }
      }
      // No need for else block - Swal automatically closes on cancel
    });
  };

  const handleRemoveAllOption = () => {
    Swal.fire({
      text: 'Are you sure want to unselect all options?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((res) => {
      if (res.isConfirmed) {
        // let selected_list = SelectedOption;
        SetSelectedOption([]); // Clear the selected list
        // SetOptionList((prev) => [...prev, ...selected_list]); // Spread both arrays
      }
    })
  };

  const handleRemoveOption = (val) => {
    SetSelectedOption((prev) => prev.filter((option) => option.school_code !== val.school_code));
    SetOptionList((prev) => {
      const mandalExists = prev.some(
        (option) => option.mandal_code === val.mandal_code
      );

      // Only add if same mandal_code is present in OptionList
      if (mandalExists) {
        return [...prev, val];
      }

      return prev; // No change if mandal_code not found
    });


  };
  const handleRowDown = (i) => {
    SetSelectedOption((prevSelectedOption) => {
      const newOptions = [...prevSelectedOption]; // Create a new array (spread operator)
      if (i !== newOptions.length - 1) {
        [newOptions[i], newOptions[i + 1]] = [newOptions[i + 1], newOptions[i]];
      }
      return newOptions;
    });
  };
  const handleRowUp = (i) => {
    if (i !== 0) {
      SetSelectedOption((prevSelectedOption) => {
        const newOptions = [...prevSelectedOption]; // Create a new array (spread operator)
        [newOptions[i], newOptions[i - 1]] = [newOptions[i - 1], newOptions[i]];
        return newOptions;
      });
    }
  };
  let componentRef = useRef();

  const scrollRef = useRef(null);
  const scrollToBottom = () => {
    if (scrollRef.current && !hideSubmit) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };
  // Trigger scroll on update when OptionList changes
  useEffect(() => {
    scrollToBottom();
  }, [OptionList]);
  function partialSave() {
    let url = config.url.CONTEXT_URL + "pre-save-candidate-school-preferences"
    let values = {

      candidateId: loginreducer?.username,
      preferences: []
    }
    SelectedOption?.forEach((val, i) => {
      values.preferences[i] = {
        schoolCode: val.school_code,    // Correct assignment for cat
        preferenceNo: i + 1,         // Correct assignment for pref (starting at 1)
      };
    });
    CommonAxiosPost(url, values).then((res) => {
      if (res?.data?.status === true) {
        Sweetalert("Successfully Saved", 'success')
      }
      else {
        Sweetalert(res?.data?.sdesc, "error")
      }
    })
  }
  return (
    <Row>


      {!hideSubmit && (
        <Col xs={5}>
          <div className="table-responsive">
            <table
              className="table table-condensed table-bordered"
              style={{ border: "1px solid skyblue" }}>
              <thead>
                <tr style={{
                  backgroundColor: "rgb(236 252 255)",
                }}>
                  <th><span>Mandal </span></th>
                  <th > {totalData?.length > 0 &&
                    <div className="input-div position-relative">
                      <Form.Group>
                        <Field
                          as="select"
                          className="form-control"
                          name='mandalCode' onChange={(e) => {
                            const mn_code = parseInt(e.target.value);

                            // Filter the mandal data
                            const mn_data = totalData?.filter(
                              (val) => val?.mandal_code === mn_code
                            );

                            // Check if any of these schools are already selected
                            const notInSelected = mn_data?.filter(
                              (item) =>
                                !SelectedOption?.some(
                                  (opt) => opt.school_code === item.school_code
                                )
                            );

                            // Add only the schools not already selected
                            SetOptionList(notInSelected);

                          }}
                        > <option value="">--Select Mandal--</option>
                          {manDetails?.map((item, i) => (
                            <option key={i} value={item?.mandal_code}>
                              {item?.block_name}
                            </option>
                          ))}</Field></Form.Group>
                      <IoIosArrowDown className="dropdown-icon" />
                    </div>}</th>
                  <th></th>
                </tr>
                <tr style={{
                  backgroundColor: "#dbe9f4",
                }}>
                  <th>S.No</th>
                  <th>School (Mandal-<small>kms from Mandal HQ</small>)</th>
                  <th>
                    {OptionList?.length > 0 && <button
                      type="button"
                      className="btn btn-sm btn-success"
                      onClick={() => handleAllOption()}
                    >All {" "}
                      <FaArrowRight
                        className="float-left"
                      />
                    </button>}</th>
                </tr>
              </thead>
              <tbody>
                {OptionList?.map((val, i) => (
                  <tr key={val.id}>
                    <td>{i + 1}</td>
                    <td>
                      <b>
                        <span
                          style={{ color: "brown", fontFamily: "Bold italic" }}>
                          {val.school_name}
                        </span>
                        ({val?.block_name} - {val?.route_distance})
                      </b>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={() => handleAddOption(val)}
                      >
                        <FaArrowRight
                          className="float-left"
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Col>
      )}
      <Col xs={7} ref={componentRef}>
        <div
          className="table-responsive"
          ref={scrollRef}
          style={{
            overflowY: "auto",
            display: "block",
            maxHeight: hideSubmit ? "none" : "650px",
          }}
        >
          <table
            className="table table-condensed table-bordered"
            id="test-table-xls-button"
            style={{ border: "1px solid skyblue" }}
          >
            <thead
              style={{
                backgroundColor: "#dbe9f4",
                border: "1px solid skyblue",
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
            >
              <tr>
                <th>Preference</th>
                <th>School (Mandal-<small>kms from Mandal HQ</small>)</th>
                {!hideSubmit && (
                  <>
                    {" "}
                    <th>
                      {SelectedOption?.length > 0 && <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={() => handleRemoveAllOption()}
                      >All {" "}
                        <FaArrowLeft
                          className="float-left"
                        // style={{ fontSize: "19px" }}
                        />
                      </button>}</th>
                    <th>Up</th>
                    <th>Down</th>
                  </>
                )}
              </tr>
            </thead>

            <tbody style={{ color: "white" }}>
              {SelectedOption?.map((val, i) => (
                <tr key={val.id} className="selectedBackground">
                  <td className="text-center">{i + 1}</td>
                  <td>
                    <b>
                      <span
                        style={{ color: "brown", fontFamily: "Bold italic" }}>
                        {val.school_name}
                      </span>
                      ({val?.block_name} - {val?.route_distance})
                    </b>
                  </td>

                  {!hideSubmit && (
                    <>
                      <td>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveOption(val)}
                        >
                          <FaArrowLeft
                            className="float-left"
                          // style={{ fontSize: "19px" }}
                          />
                        </button>
                      </td>
                      <td>
                        {i !== 0 && (
                          <button type="button" onClick={() => handleRowUp(i)}>
                            <FaArrowUpLong
                              className="float-left"
                              color="black"
                            // style={{ fontSize: "19px" }}
                            />
                          </button>
                        )}
                      </td>
                      <td>
                        {i !== SelectedOption?.length - 1 && (
                          <button
                            type="button"
                            onClick={() => handleRowDown(i)}
                          >
                            <FaArrowDownLong
                              className="float-left"
                              color="black"
                            // style={{ fontSize: "19px" }}
                            />
                          </button>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {SelectedOption?.length > 0 && (
          <div className="text-end px-2 mt-2">
            <button variant="success" type="button" onClick={() => { partialSave() }} className="btn btn-primary btn-md">Save</button> &emsp;
            <button variant="success" type="submit" className="btn btn-success btn-md">Preview & Submit</button>
          </div>)}
      </Col>
      {hideSubmit && <Col xs={3}></Col>}
    </Row>
  );
}
